import { RawPriceImprovementBlotterServerSideGrid } from './PriceImprovementBlotterServerSideGrid';
import { connectPriceImprovementBlotterServerSideGrid } from './PriceImprovementBlotterServerSideGrid.connect';

export const PriceImprovementBlotterServerSideGrid = connectPriceImprovementBlotterServerSideGrid(
  RawPriceImprovementBlotterServerSideGrid,
);
